import create from './create';
import get from './get';
import getOne from './getOne';
import del from './del';
import edit from './edit';
import countAll from './countAll';

export default {
  create,
  get,
  getOne,
  del,
  edit,
  countAll,
};



// WEBPACK FOOTER //
// ./src/services/user/index.js